import BaseRepository from "@/services/resources/repository";
import byVideo from "@/services/resources/mixins/query-by-video";
import byTheme from "@/services/resources/mixins/query-by-theme";

class Repository extends BaseRepository {
    static make(model, schema) {
        return new Repository(model, schema).$mix(byVideo).$mix(byTheme);
    }
}

export default Repository;
